import { SendMsgClientRequestBody } from '../types/sendMessageRequest.types';

const quoteEventBindingForSFMC = (value: string) => {
  if (!value || typeof value !== 'string') return value;

  return value.replace(
    /{{\s*Event\.([^.}]+)\.([^}]+?)\s*}}/g,
    (_match, eventKey, fieldPart) => {
      const trimmed = String(fieldPart).trim();

      // If already quoted leave it
      if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
        return `{{Event.${eventKey}.${trimmed}}}`;
      }

      // Quote entire field
      return `{{Event.${eventKey}."${trimmed.replace(/"/g, '\\"')}"}}`;
    },
  );
};

export const quoteRequestBodyForSFMC = (
  body: SendMsgClientRequestBody,
): SendMsgClientRequestBody => {
  const clone: SendMsgClientRequestBody = { ...body };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const quoteIfString = (v: any) =>
    typeof v === 'string' ? quoteEventBindingForSFMC(v) : v;

  clone.receiverNum = quoteIfString(clone.receiverNum);
  clone.messageId = quoteIfString(clone.messageId);
  clone.customKey1 = quoteIfString(clone.customKey1);
  clone.customKey2 = quoteIfString(clone.customKey2);
  clone.customKey3 = quoteIfString(clone.customKey3);

  if (clone.templateFields) {
    clone.templateFields = Object.fromEntries(
      Object.entries(clone.templateFields).map(([key, val]) => [
        key,
        quoteIfString(val),
      ]),
    );
  }

  return clone;
};
